// ============================================================
// logo-header.js — TAMAÑO A MANO del logo del header (props.logo_height, en px).
//
// Pedido por el dueño (22-09-2026): «¿por qué esto es tan pequeño? ¿Podría ser posible hacer
// que el logo sea redimensionable? Como las imágenes de algunas secciones». SSOT del rango y
// del estilo: lo usan el RENDER (blocks/header.js) y el ASA del editor (editor/logo-tamano.js),
// así que lo que se ve mientras se arrastra es exactamente lo que se guarda y se publica.
//
// Módulo PURO (ES2019, sin DOM ni store): node-testeable (tests/_logo_header.mjs).
// ============================================================

export const LOGO_ALTO_MIN = 32;
// Techo: la sección que abre la página baja todo lo que tapa el header fijo
// (render.js::applyFirstSectionHeaderOffset), así que un logo alto ya no le tapa el titular al
// hero; lo que hace el techo es que el header no se coma la primera pantalla (con 120 px de logo
// el de escritorio ronda los 170 px).
export const LOGO_ALTO_MAX = 120;
// Tope en móvil (lo aplica site.css sobre `img.logo-a-mano`; aquí solo se documenta el número).
export const LOGO_ALTO_MOVIL = 56;
// Proporción ancho/alto máxima de la caja del logo: la de siempre (280 × 80 = 3,5 : 1), escalada
// con la altura para que un logo apaisado también crezca al agrandarlo.
export const LOGO_PROPORCION_ANCHO = 3.5;

/**
 * Altura a mano del logo, normalizada: entero en [LOGO_ALTO_MIN, LOGO_ALTO_MAX], o `null` si no
 * hay (o no es un número) → el logo se pinta como siempre. Acepta número o cadena numérica
 * (el prop viaja por JSON); cualquier otra cosa es «sin prop». El valor acaba interpolado en un
 * `style=`: por eso sale SIEMPRE de aquí y nunca del prop a pelo.
 */
export function alturaLogo(v) {
    if (typeof v !== 'number' && typeof v !== 'string') return null;
    if (typeof v === 'string' && !v.trim()) return null;
    const n = Math.round(Number(v));
    if (!isFinite(n)) return null;
    return Math.max(LOGO_ALTO_MIN, Math.min(LOGO_ALTO_MAX, n));
}

/**
 * Estilo inline del <img> del logo. Sin altura a mano, EXACTAMENTE el de antes (los sitios ya
 * guardados no cambian ni un píxel); con ella, alto fijo y ancho proporcional, con la caja
 * escalada al mismo ritmo.
 */
export function estiloLogo(alto) {
    const comun = 'display: block; object-fit: contain; user-select: none;';
    if (alto == null) return 'max-height: 80px; max-width: 280px; ' + comun;
    return 'height: ' + alto + 'px; width: auto; max-height: none; max-width: '
        + Math.round(alto * LOGO_PROPORCION_ANCHO) + 'px; ' + comun;
}
